import BaseService from "../BaseService";
import _ from "lodash";

class OrderService extends BaseService {
    list = async (filter) => {
        var data = await this._api.post("/collaboratororder/list",filter);
        return data;
    };

    get = async ({ id } = {}) => {
        var data = await this._api.post("/collaboratororder/get", { id });
        return data;
    };

    create = async (order) => {
        var data = await this._api.post("/collaboratororder/create", order);
        return data;
    };


    update = async (order) => {
        var data = await this._api.post("/collaboratororder/update", order);
        return data;
    };



    createInvoiceFile = async ({ id } = {}) => {
        var data = await this._api.post("/collaboratororder/create_invoice", { id });
        return data;
    };

    createPackingListFile = async ({ id } = {}) => {
        var data = await this._api.post("/collaboratororder/create_packinglist", { id });
        return data;
    };


    createShippingLabelFile = async ({ id } = {}) => {
        var data = await this._api.post("/collaboratororder/create_shippinglabel", { id });
        return data;
    };



    cancel = async ({ id, reason } = {}) => {
        var data = await this._api.post("/collaboratororder/cancel", { id, reason });
        return data;
    };

    finish = async ({ id, note } = {}) => {
        var data = await this._api.post("/collaboratororder/finish", { id, note });
        return data;
    };












}
export default OrderService;
